import {
    submiteventform_FETCH_DATA_SUCCESS,
    submiteventform_HAVE_ERROR,
    submiteventform_ARE_LOADING,
  } from "../actionType";
  import HttpService from "../../utils/httpService";
  import { Get, Post } from "../../services/api.service";
  
  // Action creator function to handle different types of home primary actions
  export function submitEventFormAction(action, payload) {
    switch (action) {
      case submiteventform_HAVE_ERROR:
        return {
          type: action,
          hasError: payload,
        };
  
      case submiteventform_ARE_LOADING:
        return {
          type: action,
          isLoading: payload,
        };
  
      case submiteventform_FETCH_DATA_SUCCESS:
        return {
          type: action,
          event: payload,
        };
  
      default:
        return;
    }
  }
  
  // Async action creator function to fetch home primary data
  export function submitEventFormFetchData(formData) {
    return (dispatch) => {
      try {
        // Dispatch loading action  
        
        dispatch(submitEventFormAction(submiteventform_ARE_LOADING, true));
  
        // Make POST request with form data
        return new Promise((resolve, reject) => {
          Post(HttpService.submiteventform, formData)
            .then((result) => {
              // Dispatch success action
              dispatch(submitEventFormAction(submiteventform_FETCH_DATA_SUCCESS, result));
              resolve(result);
            })
            .catch((error) => {
              // Dispatch error action
              dispatch(submitEventFormAction(submiteventform_HAVE_ERROR, true));
              reject(error);
            });
        });
      } catch (error) {
        // Dispatch error action for any other errors
        dispatch(submitEventFormAction(submiteventform_HAVE_ERROR, true));
      }
    };
  }
  